import { render, staticRenderFns } from "./InventoryDistribution.vue?vue&type=template&id=bf944e42&"
import script from "./InventoryDistribution.vue?vue&type=script&lang=ts&"
export * from "./InventoryDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports